/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */
import { apiFetch, multiFetchApi } from '../../../apiClient';
import { apiMap, settings } from '../../../config/constants';
import paths from '../../../config/path';
import history from '../../../utils/history';
import { saveSessionDatas, setItemToSession, deepClone, getSessionDatas, getCountryListFormLang} from '../../../utils'
import {
    handleInputError,
    saveAppInfo,
    showLoaing,
    saveRetrvInfo,
    saveBusinessInfo,
    saveSectionInfo,
    saveCountryList,
    saveAllContryList,
    saveIndustryLevelList,
    saveResOrBusOpeSitCodeLevelList} from '../../App/state/action';
import { installAOFormJsonTree2 as installAOFormJsonTree } from '../../../utils/AOFormJsonHandler2'

// 获取图片验证码
export const getImageCode = (reqDatas, callBack) => dispatch => { 
    const imageCodeParmas = {
        hostname: settings.hostnameImageCode, 
        paramsObj: {
        },
        headers: {
            ...settings.otpClientHeaders
        },
        method: settings.get,
        noNeedToken: true
    }
    apiFetch(apiMap.getImageCode, imageCodeParmas)(dispatch)
        .then(response => {
            dispatch(handleInputError(false));
            callBack(response);
        })
        .catch( error => {
            error && dispatch(handleInputError(error));
        });
}

// 图片验证 + 获取sms
export const getOTP = (datas, callBack) => dispatch => { 
    const smsParmas = {
        hostname: settings.hostnameOTP, 
        paramsObj: {
            ...datas
        },
        headers: {
            ...settings.otpClientHeaders
        },
        method: settings.post,
        noNeedToken: true
    }
    apiFetch(apiMap.getOTP, smsParmas)(dispatch)
        .then(response => {
            saveSessionDatas(response.respBody, ["requestId", "guId"]);
            dispatch(handleInputError(false));
            callBack(true);
        })
        .catch( error => {
            saveSessionDatas({ requestId: null, guId: null}, ["requestId", "guId"]);
            if (error.errorCode === "RBBOOB08" || error.errorCode === "RBBOOB09" || error.errorCode === "RBBOOB10"){
                error && dispatch(handleInputError(true,error.errorCode,"imageCode")); // 图片验证码
            } else if (error.errorCode === "RBBOOB04" || error.errorCode === "RBBOOB06"){
                error && dispatch(handleInputError(true,error.errorCode,"moblie"));
            } else {
                error && dispatch(handleInputError(error));
            }
            callBack(false);
        });
}

// 验证sms
export const verifyOTP = (reqDatas) => dispatch => {
    const logonParams = {
        hostname: settings.hostnameLogon,
        paramsObj: reqDatas,
        method: settings.post,
        noNeedToken: true
    };
    dispatch(showLoaing(true));
    const { applicationId, intVersion } = getSessionDatas();
    if (applicationId && intVersion) {
        saveUserInfo(applicationId, intVersion)(dispatch);
    } else {
        let applicationId = "", intVersion = 0;
        apiFetch(apiMap.logon, logonParams)(dispatch)
        .then( response => {
            dispatch(handleInputError(false));
            const resp = response.respBody;
            if(resp.applications && resp.applications.length > 0){
                applicationId = resp.applications[0].id ? resp.applications[0].id : "";
                intVersion = resp.applications[0].intVersion ? resp.applications[0].intVersion : 0;
            }
            setItemToSession({ 
                headerInfo : response.headerInfo || {}, 
                createTime: resp.createTime || "", 
                applicationId: applicationId,
                intVersion: intVersion
            });
            saveUserInfo(applicationId, intVersion)(dispatch);
        })
        .catch( error => {
            dispatch(showLoaing(false));
            error && dispatch(handleInputError(true,error.errorCode,"varifyCode"));
        });
    }
}

const saveUserInfo = (applicationId, intVersion) => dispatch =>{
    const retrvParams = {
        hostname: settings.hostnameApplication,
        method: settings.get
    };
    const businessParams = {
        hostname: settings.hostBusiness,
        method: settings.get
    };
    const sectionTemplateParams = {
        hostname: settings.hostnameSection,
        method: settings.get
    };
    const staticDataParams = {
        hostname: settings.hostnameStaticData,
        method: settings.get
    };
    multiFetchApi([
        apiMap.retrvApp(applicationId),
        apiMap.getBusinessInfo(applicationId),
        apiMap.getSectionTemplate(getSessionDatas().intVersion,"CN"),
        apiMap.getStaticData(0)],[
        retrvParams,
        businessParams,
        sectionTemplateParams,
        staticDataParams])(dispatch)
            .then(([retrvResult,businessResult,sectionResult,staticDataResult]) => {
                dispatch(showLoaing(false));
                staticDataResult.respBody = JSON.parse(staticDataResult.respBody)
                saveResultToStore(retrvResult, businessResult, sectionResult, staticDataResult)(dispatch);
            }).catch( error => {
                dispatch(showLoaing(false));
            });
}
const saveResultToStore = (retrvResult,businessResult,sectionResult, staticDataResult) => dispatch => {
    const retrvInfo = retrvResult.respBody;
    const businessInfo = businessResult.respBody;
    const sectionInfo = sectionResult.respBody;
    const retrvStaticData = staticDataResult.respBody;
    const industryLevelList = retrvStaticData[1].roots
    let countryList
    if(retrvStaticData[3]){
        countryList = [retrvStaticData[3].roots, retrvStaticData[0].roots]; 
    } else {
        countryList = [retrvStaticData[0].roots, retrvStaticData[0].roots];  
    }
    const countryListResult = getCountryListFormLang(countryList);

    let resOrBusOpeSitCodeLevelDatasRoots;
    if(retrvStaticData[4]){
        resOrBusOpeSitCodeLevelDatasRoots = retrvStaticData[4].roots;
    }
    //const resOrBusOpeSitCodeLevelDatasRoots = retrvStaticData[4].roots;

    dispatch(saveRetrvInfo(retrvInfo));
    dispatch(saveBusinessInfo(businessInfo));
    dispatch(saveSectionInfo(sectionInfo));
    dispatch(saveCountryList(countryList));
    dispatch(saveAllContryList(countryList));
    //area code
    dispatch(saveResOrBusOpeSitCodeLevelList(resOrBusOpeSitCodeLevelDatasRoots));
    dispatch(saveIndustryLevelList(retrvStaticData[1]));
    
    const newAppInfo = deepClone(retrvInfo);
    const newSectionInfo = deepClone(sectionInfo);
    newAppInfo.sections = newSectionInfo;
    installAOFormJsonTree(newAppInfo, businessInfo, countryListResult,industryLevelList,resOrBusOpeSitCodeLevelDatasRoots);
    newAppInfo.companyInfo = businessInfo.companyInfo;
    dispatch(saveAppInfo(newAppInfo))

    gotoProgressPage(retrvInfo);  
}

const gotoProgressPage = (retrvInfo) => {
    saveSessionDatas({ requestId: null, guId: null}, ["requestId", "guId"]);
    const status = retrvInfo.status;
    const progressIndex = retrvInfo.progressIndex;
    if (status === 0) { //0: initial
        history.push(paths.accountOpeningSteps.path);
    } else if (status === 1) { //1: inprogress
        history.push(pagePathList[progressIndex]);
    } else if (status === 2 || status === 5) { //2: frozen
        history.push(paths.appointment.path);
    } else if (status === 3) { //3: rejected
        history.push(paths.confirmPQ.path);
    } else if (status === 4) { //4: reset
        history.push(paths.dashboard.path);
    }
}

const pagePathList = [
    paths.companyRegistration.path,
    paths.basicInfo.path,
    paths.accountQuestion.path,
    paths.previewQuestion.path,
    paths.dashboard.path,
    paths.systemErrorMessage.path,
];

/*
status: 0: initial, 
        1: inprogress,
        2: frozen, 
        3: rejected, 
        4: reset
progressIndex: 0: company registration
               1: company review
               2: questionnaire
               3: registration Review
               4: AO form/ file list
*/



// WEBPACK FOOTER //
// ./src/views/Logon/state/action.js